import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { Column, Float } from "uikit";

import { useTypedSelector } from "../../redux/store";
import { SVGSourceGeneral } from "../../utils/generalSprite";
import RightMenu from "../../pages/MainPage/pages/Orders/components/RightMenu";
import CallsList from "../../pages/MainPage/pages/Orders/components/OrderRightMenu/components";
import ModalController from "../ModalController/Controller";
import { UpdateNoticeBoundary } from "../UpdateNotice";

import Header from "./components/Header";

const StyledMainPage = styled.div`
	width: 100vw;
	height: 100vh;
	background-color: white;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: stretch;
	overflow: hidden;

	.page {
		flex: 1 1 0;
		min-width: 0;
		max-width: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		& > div {
			height: 100%;
			min-width: 0;
			max-width: 100%;

			& > div > div {
				height: 100%;
				min-width: 0;
				max-width: 100%;
			}
		}
	}

	.rightMenuContent {
		position: relative;
		width: 56px;
		height: 100%;
		border-left: 1px solid #dee0e2;

		background: white;

		z-index: 2000;
	}

	.softFon {
		position: fixed;
		right: 70px;
		bottom: 3px;
		display: flex;
		/* height: 100%; */
		width: 342px;
		flex-direction: column;
		/* justify-content: flex-end; */
		/* align-items: flex-end; */
		z-index: 1;
	}
`;

type Props = PropsWithChildren;

/**
 * While the connection is lost the header stays above the «Connection lost»
 * overlay (z-index 18000), so the connection indicator can be hovered; its
 * panel opens in the header's own float container. Otherwise no z-index:
 * modals cover the header as before (dev check G3).
 */
const HeaderLayer = styled.div<{ raised: boolean }>`
	position: relative;
	${({ raised }) => (raised ? "z-index: 18001;" : "")}
`;

const MainLayout: React.FC<Props> = ({ children }) => {
	const isOpen = useTypedSelector((state) => state.softphoneWidget.isOpen);
	const connected = useTypedSelector((state) => state.prpc.connected);
	return (
		<StyledMainPage>
			<SVGSourceGeneral />
			<div
				className="page"
				key="main-page"
				style={{
					position: "relative",
				}}
			>
				<Float.Container id="page-content">
					<Float.Tracker id="page-content">
						<Column sizes="auto! 1fr" maxedWidth maxedHeight>
							<HeaderLayer raised={!connected}>
								<Float.Container id="header">
									<Header />
								</Float.Container>
							</HeaderLayer>

							<UpdateNoticeBoundary>
								{children}
							</UpdateNoticeBoundary>
						</Column>
						<ModalController />
					</Float.Tracker>
				</Float.Container>
			</div>
			<div className="rightMenuContent">
				<RightMenu />
				{!isOpen && <CallsList />}
			</div>
		</StyledMainPage>
	);
};

export default MainLayout;
